import styled from 'styled-components'

export const CreatePaymentMethodFormStyled = styled.div`
  height: 100%;
`
